/* eslint-disable max-len */
/* eslint no-console: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'
import PresencialFinance from '../../../../../presentation/pages/dashboard/finance/presencial'
import { makeStats } from '../../../../usecases/stats/load-stats'
import { useMe } from '../../../../../presentation/contexts/me'
import { makeGeneralStats, presetPeriods } from './constants'
import { calculateIntervalFor } from '../../../../../presentation/helpers/helper-date'
import { usePage } from '../../../../../presentation/contexts/page'

class Filter {
  filter: any = {}

  setPeriod(period: 'month' | 'week' | 'today' | 'custom') {
    this.filter.period = period
    return this
  }

  setCustomPeriod(from: any, to: any) {
    this.filter.initialDate = from
    this.filter.finishDate = to
    return this
  }

  setPaymentTypeId(paymentTypeId: number) {
    this.filter.paymentTypeId = paymentTypeId
    return this
  }

  setDetachedDays(days: string[]) {
    this.filter.detachedDays = days
    return this
  }

  setKindOfPaymentMethods(paymentMethod: null | number) {
    if (paymentMethod) {
      this.filter.paymentMethod = paymentMethod
    }
    return this
  }

  build() {
    return this.filter
  }
}

const MakePresencialFinance = () => {
  const { me } = useMe()
  const { setHeader } = usePage()

  const [generalStats, setGeneralStats] = useState(null)
  const [productsRanking, setProductsRanking] = useState(null)
  const [totalRaised, setTotalRaised] = useState(null)
  const [paymentMethods] = useState([{ name: 'Todos', value: null }, { name: 'Dinheiro', value: 2 }, { name: 'Crédito', value: 1 }, { name: 'Débito', value: '0' }])
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any>(null)
  const [hasCustomPeriod, setHasCustomPeriod] = useState(false)
  const [selectedBars, setSelectedBars] = useState<string[]>([])
  const [from, setFrom] = useState(null)
  const [to, setTo] = useState(null)
  const [queryparams, setQueryparams] = useState({})
  const [loadingDownload, setLoadingDownload] = useState(false)
  const [selectedPresetPeriod, setSelectedPresetPeriod] = useState({
    id: 'today',
    label: 'Hoje',
  })

  const formatToMonthYear = (dateString: string) => {
    const dateParts = dateString.split('/')
    const month = dateParts[0]
    const year = dateParts[2]
    const formattedDate = `${month}/${year}`

    return formattedDate
  }

  const extractDateGroup = (data: any) => {
    if (!data) return { labels: [], values: [], grouped: data }

    let labels = Object.keys(data)
    let values = Object.values(data)
    let grouped = data
    const intervalIsGreaterThanAMonth = calculateIntervalFor(labels[0], labels[labels.length - 1]) > 31
    if (intervalIsGreaterThanAMonth) {
      const dates = {} as any
      const dateGroup = {} as any
      labels.forEach((date) => {
        const label = formatToMonthYear(date)
        const acc = dates[label] ?? 0
        dates[label] = acc + data[date]

        const gAcc = dateGroup[label] ?? []
        dateGroup[label] = [...gAcc, date]
      })

      grouped = dateGroup
      labels = Object.keys(dates)
      values = Object.values(dates)
    }

    return { labels, values, grouped }
  }

  const { labels, values, grouped: groupedIdsBars } = extractDateGroup(totalRaised)

  const handleToggleBarsInList = (index: number) => {
    setSelectedBars((state) => {
      const currentRaised = Object.keys(groupedIdsBars).length > 0 ? Object.keys(groupedIdsBars)[index] : totalRaised && Object.keys(totalRaised)[index]

      if (!currentRaised) return state

      const barsAlreadySelected = state.find((raised) => raised === currentRaised)
      if (barsAlreadySelected) {
        return state.filter((raised) => raised !== currentRaised)
      }

      return [...state, currentRaised]
    })
  }

  const loadTotalRaised = async (query?: any) => {
    try {
      if (!me?.stablishments[0]?.id) return
      const stats = await makeStats().loadTotalRaised(me.stablishments[0].id, query ?? queryparams)

      setTotalRaised(stats)
    } catch (err) {
      console.log(err)
    }
  }

  const convertDateFormat = (date: string) => {
    if (date.length === 7) return date
    const parts = date.split('/')
    const newDate = `${parts[1]}/${parts[0]}/${parts[2]}`
    return newDate
  }

  const formatTotalRaisedToChart = (data: any) => {
    if (!data) return null

    const colors = labels.map((label: any) => {
      const doesLabelSelected = selectedBars.find((b) => b === label)

      return doesLabelSelected || selectedBars.length === 0 ? '#DF5605' : '#FFCEB0'
    })

    return {
      labels: labels.map(convertDateFormat),
      datasets: [
        {
          label: 'Valor Total',
          data: values,
          backgroundColor: colors,
          borderRadius: 8,
        },
      ],
    }
  }

  const loadProductsRanking = async (query?: any) => {
    try {
      if (!me?.stablishments[0]?.id) return
      const stats = await makeStats().loadProductRanking(me.stablishments[0].id,
        query ?? queryparams)

      const the8Firsts = stats.slice(0, 7)

      setProductsRanking(the8Firsts)
    } catch (err) {
      console.log(err)
    }
  }

  const loadGeneralStats = async (query?: any) => {
    try {
      if (!me?.stablishments[0]?.id) return
      const stats = await makeStats().loadGeneral(me.stablishments[0].id, query ?? queryparams)
      const formattedStats = makeGeneralStats(stats) as any
      setGeneralStats(formattedStats)
    } catch (err) {
      console.log(err)
    }
  }

  const handleDownload = async () => {
    try {
      setLoadingDownload(true)
      if (!me?.stablishments[0]?.id) return
      const aFilter = new Filter()
      if (hasCustomPeriod && from) {
        aFilter
          .setPeriod('custom')
          .setCustomPeriod(from, to)
      } else if (selectedPresetPeriod) {
        aFilter.setPeriod(selectedPresetPeriod?.id as any)
      }

      if (selectedBars.length > 0) {
        aFilter
          .setDetachedDays(selectedBars)
      }
      const filter = aFilter.build()
      await makeStats().downloadStats(me.stablishments[0].id, filter ?? queryparams)
    } catch (err) {
      console.log(err)
    } finally {
      setLoadingDownload(false)
    }
  }

  const handleApplyFilter = () => {
    const aFilter = new Filter()
    if (hasCustomPeriod && from) {
      aFilter
        .setPeriod('custom')
        .setCustomPeriod(from, to)
    } else if (selectedPresetPeriod) {
      aFilter.setPeriod(selectedPresetPeriod?.id as any)
    }

    if (selectedBars.length > 0) {
      aFilter
        .setDetachedDays(selectedBars)
    }

    const intervalIsGreaterThanAMonth = calculateIntervalFor(labels[0], labels[labels.length - 1]) > 31
    if (intervalIsGreaterThanAMonth) {
      const dates = selectedBars.reduce((acc: string[], current) => {
        if (groupedIdsBars[current]) {
          return [...acc, ...groupedIdsBars[current]]
        }
        return [...acc]
      }, [])

      aFilter
        .setDetachedDays(dates)
    }

    aFilter.setKindOfPaymentMethods(selectedPaymentMethod)

    const filter = aFilter.build()

    setQueryparams(filter)
    loadTotalRaised(filter)
    loadGeneralStats(filter)
    loadProductsRanking(filter)
  }

  const handleToggleCustomPeriod = () => {
    setHasCustomPeriod((state) => !state)
  }

  const handleSelectPeriod = (period: any) => {
    setSelectedPresetPeriod(period)
  }

  const handleSelectPaymentMethods = (paymentMethod: any) => {
    setSelectedPaymentMethod((state: any) => {
      if (state === paymentMethod?.value) {
        return null
      }
      return paymentMethod.value
    })
  }

  useEffect(() => {
    handleApplyFilter()
  }, [selectedBars])

  useEffect(() => {
    setSelectedBars([])
    handleApplyFilter()
  }, [selectedPresetPeriod, hasCustomPeriod])

  useEffect(() => {
    loadGeneralStats()
    loadProductsRanking()
    loadTotalRaised()
  }, [me])

  useEffect(() => {
    (async () => {
      setHeader({
        title: '',
        goTo: null,
      })
    })()
  }, [me])

  const raisedFormatted = formatTotalRaisedToChart(totalRaised)

  return (
    <PresencialFinance
      onFrom={setFrom}
      from={from}
      to={to}
      onTo={setTo}
      generalStats={generalStats}
      productsRanking={productsRanking}
      chartOptions={raisedFormatted}
      presetPeriods={presetPeriods}
      onSelectPaymentMethod={handleSelectPaymentMethods}
      selectedPaymentMethod={selectedPaymentMethod}
      paymentMethods={paymentMethods}
      onSelectPeriod={handleSelectPeriod}
      selectedPeriod={selectedPresetPeriod}
      onToggleCustomPeriod={handleToggleCustomPeriod}
      hasCustomPeriod={hasCustomPeriod}
      onApplyFilter={handleApplyFilter}
      onDownload={handleDownload}
      loadingDownload={loadingDownload}
      onToggleBarsInList={handleToggleBarsInList}
    />
  )
}

export default MakePresencialFinance
